import { IApplicationState } from '../../types/redux';

export function getGalleryMedia(state: IApplicationState) {
  return state.galleryMedia;
}
